import * as React from "react";
import { Modal } from "antd";
import Form, { FormComponentProps, WrappedFormUtils } from "antd/lib/form/Form";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "./CommissionCalculationDescriptionModal.scss";
import { PercentageMask } from 'src/util/Masks/PercentageMask';
import FormulaDescription from '../formula-description/FormulaDescription';
import { IPricing } from 'src/services/interfaces/calculator/IPricing';
import { formatCurrency } from 'src/util/Masks/formatCurrency';

interface ICommissionCalculationDescriptionModal {
  pricing?: IPricing;
  form?: WrappedFormUtils;
  OnCancel: () => void;
}

export function CommissionCalculationDescriptionModal(props: ICommissionCalculationDescriptionModal & FormComponentProps & RouteComponentProps<any>) {
  const economy = props.pricing.maxPrice - props.pricing.price;
  return (
    <Modal
      title="Detalhe do calculo da comissão"
      visible={true}
      maskClosable={false}
      onCancel={props.OnCancel}
      className="modal-small"
      centered
    >
      <div className="region-container pricing-info">
        <div className="region-container">
          <FormulaDescription
            title={"Preço"}
            result={formatCurrency(props.pricing.price)} />

          <FormulaDescription
            title={"Preço Máximo"}
            result={formatCurrency(props.pricing.maxPrice)} />

          <FormulaDescription
            title={"Economia"}
            descriptiveFormula={"Preço máximo - Preço atual"}
            filledFormula={`${formatCurrency(props.pricing.maxPrice)} - ${formatCurrency(props.pricing.price)}`}
            result={formatCurrency(economy)} />

          <FormulaDescription
            title={"Comissão Mínima"}
            descriptiveFormula={"Comissão percentual Officer * Preço"}
            filledFormula={`${PercentageMask(props.pricing.commission?.officer?.defaultOfficerCommissionValue, 2, 2)} * ${formatCurrency(props.pricing.maxPrice)}`}
            result={formatCurrency(props.pricing.commission?.officer?.full.minValue)} />

          <FormulaDescription
            title={"Comissão Máxima"}
            descriptiveFormula={"Preço Máximo * Kicker + Comissão Mínima"}
            filledFormula={`${formatCurrency(props.pricing.maxPrice)} * ${PercentageMask(props.pricing?.commission?.officer?.commissionKicker, 2, 2)} + ${formatCurrency(props.pricing.commission?.officer?.full.minValue)}`}
            result={formatCurrency(props.pricing?.commission?.officer?.full?.maxValue)} />

          <FormulaDescription
            title={"Comissão"}
            descriptiveFormula={"Economia * Kicker + Comissão Minima (não se aplica nos calculos via admin)"}
            filledFormula={`${formatCurrency(economy)} * ${PercentageMask(props.pricing?.commission?.officer?.commissionKicker, 2, 2)} + ${formatCurrency(props.pricing.commission?.officer?.full?.minValue)}`}
            result={formatCurrency(props.pricing?.commission?.officer?.full?.value)} />

          <FormulaDescription
            title={"Comissão Percentual"}
            descriptiveFormula={"Comissão / Preço"}
            filledFormula={`${formatCurrency(props.pricing?.commission?.officer?.full?.value)} / ${formatCurrency(props.pricing.price)}`}
            result={PercentageMask(props.pricing?.commission?.officer?.full?.percentage, 2, 2)} />
        </div>
      </div>
    </Modal>
  );
}

export default withRouter(Form.create()(CommissionCalculationDescriptionModal));



// WEBPACK FOOTER //
// ./src/pages/monitor/my-quotes/commission-information/CommissionCalculationDescriptionModal.tsx